import { Component, Input } from '@angular/core';
import { PFFormatAddress } from '../../../../data/interfaces/circle-credit.interface';

@Component({
  selector: 'app-circle-credit-address-card',
  templateUrl: './circle-credit-address-card.component.html',
  styleUrls: ['./circle-credit-address-card.component.scss']
})
export class CircleCreditAddressCardComponent {
  @Input() data: PFFormatAddress | null = null;

  get hasData(): boolean {
    if (!this.data) return false;
    
    const essentialFields = ['address', 'city', 'state', 'postalCode'];
    return essentialFields.some(field => this.data![field as keyof PFFormatAddress]);
  }

  get completionPercentage(): number {
    if (!this.data) return 0;
    
    const allFields = [
      'address', 'neighborhood', 'municipality', 'city', 'state',
      'postalCode', 'residenceDate', 'phoneNumber', 'addressType',
      'settlementType', 'addressOrigin'
    ];
    
    const filledFields = allFields.filter(field => {
      const value = this.data![field as keyof PFFormatAddress];
      return value !== null && value !== undefined && value !== '';
    });
    
    return Math.round((filledFields.length / allFields.length) * 100);
  }

  get statusClass(): string {
    if (!this.hasData) return 'status-empty';
    
    const percentage = this.completionPercentage;
    if (percentage < 30) return 'status-incomplete';
    if (percentage < 70) return 'status-partial';
    return 'status-complete';
  }

  get fullAddress(): string {
    if (!this.data) return 'No especificado';
    
    const parts = [
      this.data.address,
      this.data.neighborhood,
      this.data.municipality,
      this.data.city,
      this.data.state,
      this.data.postalCode
    ].filter(part => part && part.trim());
    
    return parts.join(', ') || 'No especificado';
  }

  formatDate(date: string | undefined): string {
    if (!date) return 'No especificado';
    
    try {
      return new Date(date).toLocaleDateString('es-MX');
    } catch {
      return date;
    }
  }

  formatPhone(phone: string | undefined): string {
    if (!phone) return 'No especificado';
    
    // Formato básico para teléfonos mexicanos
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  }
}
